import { render, staticRenderFns } from "./UnsavedChangesWarningDialog.vue?vue&type=template&id=65efeedc&scoped=true&"
import script from "./UnsavedChangesWarningDialog.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesWarningDialog.vue?vue&type=style&index=0&id=65efeedc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efeedc",
  null
  
)

export default component.exports